import packageInfo from '../../package.json';
import gitInfo from '../../git-version.json';

const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const usePublicBlockscoutHost = hostname === 'dths-uat.dths.molaris.local' || hostname === 'dths2.molaris.hu';
// const blockchainExplorerUrl = 'http://blockscout-test.blockchain.molaris.local/';
const blockchainExplorerUrl = usePublicBlockscoutHost
  ? 'https://blockscout.molaris.hu/'
  : 'http://blockscout-test.blockchain.molaris.local/';

export const environment = {
  production: false,
  appVersion: packageInfo.version,
  appDescription: packageInfo.description,
  gitDate: gitInfo?.git?.date,
  gitSha1: gitInfo?.git?.sha1.slice(0, 8),
  gitBranch: gitInfo?.git?.branch,
  buildNumber: gitInfo?.buildNumber,
  showVersionInfo: true,
  apiBaseUrl: `/api`,
  blockchainExplorerUrl,
  api: {
    timeout: 30000,
    proxy: '',
  },
};
